import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@telegram-apps/telegram-ui";
import { api } from "../../lib/api.js";
import { usePageBack } from "../../lib/telegram.js";

// Quick overview: totals for users / airfields / pending docs. Cheap reads
// from the same endpoints the dedicated pages use, with limit=1 so we just
// get the totals where applicable.
const STAT_CARDS = [
  {
    key: "users",
    icon: "👥",
    label: "Пилоты",
    hint: "Учётных записей",
    to: "/superadmin/users",
  },
  {
    key: "airfields",
    icon: "🛫",
    label: "Аэродромы",
    hint: "Зарегистрировано",
    to: "/superadmin/airfields",
  },
  {
    key: "pendingDocs",
    icon: "📎",
    label: "Документы",
    hint: "На проверке",
    to: "/superadmin/documents",
  },
];

export default function SuperadminDashboard() {
  usePageBack("/");
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    Promise.all([
      api("/api/v1/superadmin/users?limit=1"),
      api("/api/v1/superadmin/airfields"),
      api("/api/v1/superadmin/documents?status=pending&limit=1"),
      api("/api/v1/superadmin/warnings?limit=1"),
    ])
      .then(([users, airfields, docs, warnings]) => {
        setStats({
          users: users.total ?? 0,
          airfields: airfields.airfields?.length ?? 0,
          pendingDocs: docs.documents?.length ?? 0,
          recentWarning: warnings.warnings?.[0] ?? null,
        });
      })
      .catch((e) => setError(e.message));
  }, []);

  if (error) {
    return (
      <div className="portal-card">
        <p className="portal-empty">Ошибка: {error}</p>
      </div>
    );
  }
  if (!stats) {
    return (
      <div className="portal-card" style={{ display: "flex", justifyContent: "center" }}>
        <Spinner size="m" />
      </div>
    );
  }

  return (
    <>
      <section>
        <header className="portal-card__header" style={{ padding: "0 4px" }}>
          <h2 className="portal-card__title">Состояние</h2>
        </header>
        <div className="portal-stat-grid">
          {STAT_CARDS.map((card) => (
            <button
              key={card.key}
              type="button"
              className="portal-stat portal-stat--clickable"
              onClick={() => navigate(card.to)}
              style={{ textAlign: "left", font: "inherit", border: "1px solid var(--portal-border)" }}
            >
              <div className="portal-stat__label">
                <span className="portal-stat__icon" aria-hidden="true">{card.icon}</span>
                {card.label}
              </div>
              <div className="portal-stat__value">{stats[card.key]}</div>
              <div className="portal-stat__hint">{card.hint}</div>
            </button>
          ))}
        </div>
      </section>

      <section className="portal-card">
        <header className="portal-card__header">
          <h2 className="portal-card__title">Последнее предупреждение</h2>
        </header>
        {stats.recentWarning ? (
          <div className="portal-warning">
            <div className="portal-warning__body">{stats.recentWarning.reason}</div>
            <div className="portal-warning__meta">
              {stats.recentWarning.airfield_name} · {new Date(stats.recentWarning.created_at).toLocaleString("ru-RU")}
            </div>
          </div>
        ) : (
          <p className="portal-empty">Пока нет предупреждений.</p>
        )}
      </section>
    </>
  );
}
